/* eslint-disable react/jsx-props-no-spreading */
import { Typography } from 'palette/Typography';
import { BodyProps } from '../types';

function BodyText({ level, ...props }: React.PropsWithChildren<Omit<BodyProps, 'type'>>) {
    return (
        <Typography
            level={level || '2'}
            type="body"
            {...props}
        />
    );
}

export default BodyText;
